function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 39H21V27h-4.5a4.49 4.49 0 01-4.5-4.5 4.49 4.49 0 014.5-4.5h9a4.49 4.49 0 014.5 4.5V39h1.5a4.49 4.49 0 014.5 4.5 4.49 4.49 0 01-4.5 4.5h-15a4.49 4.49 0 01-4.5-4.5 4.49 4.49 0 014.5-4.5zM24 12A6 6 0 1123.99.01 6 6 0 0124 12z"
})));